import React from 'react';

const MapBoxContext = React.createContext<string>(
  process.env.MAPBOX_ACCESS_TOKEN as string,
);

export default MapBoxContext;
